<div class="content-wrapped">
  <div class="container-xxl flex-grow-1 main-title-container">
      <div class="d-flex align-items-center">
          <h4 class="fw-bold pt-3 text-primary me-2">
              <mat-icon class="align-middle head-icon">table_border</mat-icon>
          </h4>
          <div class="title-container">
              <small>{{campaign.name}} <span class="arrow">></span> {{project.nombre}} </small>
              <h2>Diagramación</h2>
          </div>
      </div>
  </div>
  <div class="container-xxl flex-grow-1 my-3">
    <button mat-raised-button class="nest-button" [routerLink]="'/admin/projects/'+ campaign.id">
        <mat-icon>arrow_back</mat-icon><span class="nb-text">Atrás</span>
    </button>
  </div>
  <div class="row">
      <div class="col-md-12">
          <div class="card mb-4">
              <div class="heading-container">
                  <div class="button-container">
                      <button *ngIf="hasPermissions('crear_diag',null,true)" mat-raised-button (click)="openEditProjectDiagramDialog(false)" class="nest-button">
                          <mat-icon>add_circle</mat-icon><span class="nb-text">Nueva diagramación</span>
                      </button>
                      <button *ngIf="hasPermissions('ver_inv_diag',null,true)" (click)="openInventoryDialog()" mat-raised-button class="nest-button">
                          <mat-icon>inboxes</mat-icon><span class="nb-text">Inventario</span></button>
                      <button *ngIf="hasPermissions('dist_diag',null,true)" mat-raised-button class="nest-button" (click)="openDistributionDialog()">
                          <mat-icon>table</mat-icon><span class="nb-text">Distribución</span>
                      </button>
                      <button *ngIf="hasPermissions('upl_artes',null,true)" mat-raised-button class="nest-button" (click)="openUploadArtMultiFIleDialog()">
                        <mat-icon>file_upload</mat-icon><span class="nb-text">Subir artes</span>
                      </button>
                       <button mat-raised-button class="nest-button" (click)="openAutomaticVobo()">
                          <mat-icon>format_list_numbered</mat-icon><span class="nb-text">VoBos. Consecutivos</span>
                      </button>

                   
                    <!--  <button mat-raised-button class="nest-button show-on-large" (click)="openProjectSummary()">
                        <mat-icon>inventory_2</mat-icon><span class="nb-text">Inv. Disponible</span>
                      </button>
                      <button *ngIf="hasPermissions('datos_pago',null,true)" mat-raised-button class="nest-button show-on-large" (click)="getPromoFactFile()">
                        <mat-icon>file_download</mat-icon><span class="nb-text">Datos de Pago</span>
                      </button>
                      <button *ngIf="hasPermissions('gen_excel',null,true)" mat-raised-button class="nest-button show-on-large" (click)="getExcelDiagramas()">
                          <mat-icon>table_chart</mat-icon><span class="nb-text">Generar Excel</span>
                      </button>
                     <button mat-raised-button class="nest-button" (click)="OpenImportDiagrama()">
                          <mat-icon>input</mat-icon><span class="nb-text">Importar Diagramaciones</span>
                      </button>
                      <button mat-raised-button class="nest-button" (click)="OpenExportDiagrama()">
                          <mat-icon>open_in_new</mat-icon><span class="nb-text">Exportar Diagramaciones</span>
                      </button>-->
                      <!-- button gruop -->
                      <button mat-raised-button class="nest-button" [matMenuTriggerFor]="moreMenu">
                          <mat-icon>more_horiz</mat-icon><span class="nb-text">Más</span>
                      </button>
                      <mat-menu #moreMenu="matMenu">
                        <button mat-menu-item (click)="openProjectSummary()">
                          <mat-icon>inventory_2</mat-icon><span>Inv. disponible</span>
                        </button>
                        <button *ngIf="hasPermissions('datos_pago',null,true)" mat-menu-item (click)="getPromoFactFile()">
                          <mat-icon>file_download</mat-icon><span>Datos de pago</span>
                        </button>
                        <button *ngIf="hasPermissions('gen_excel',null,true)" mat-menu-item (click)="getExcelDiagramas()">
                            <mat-icon>table_chart</mat-icon><span>Generar excel</span>
                        </button>
                       <button mat-menu-item (click)="OpenExportDiagrama()">
                          <mat-icon>open_in_new</mat-icon><span class="nb-text">Exportar diagramaciones</span>
                        </button>
                        <button  mat-menu-item  (click)="OpenImportDiagrama()">
                          <mat-icon>input</mat-icon><span class="nb-text">Importar diagramaciones</span>
                        </button>
                       <button  mat-menu-item (click)="OpenExportSharedArtsDiagrama()">
                          <mat-icon>apps</mat-icon><span class="nb-text">Artes Compartidos</span>
                        </button>
                      </mat-menu>
                    </div>
                </div>

               <div class="row align-items-end" style="margin-left: 0.03rem !important"> 
                    <div class="col-auto"> 
                        <mat-form-field appearance="outline" class="mb-0 custom-search-field filters-diag">
                            <mat-icon matPrefix>search</mat-icon>
                            <input matInput placeholder="Buscar..." [(ngModel)]="searchText">
                            <button *ngIf="searchText" matSuffix mat-icon-button aria-label="Clear" (click)="searchText=''">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>

                    <div class="col-auto">
                        <mat-form-field appearance="outline" class="form-field same-height filters-diag"> <mat-label>Ver</mat-label>
                            <mat-select [(ngModel)]="selectVerDiagramacion" (selectionChange)="updateSelectDiagramations()">
                                <mat-option value="1">Solo asignadas a mi</mat-option>
                                <mat-option value="2">Todas</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-auto">
                        <mat-form-field appearance="outline" class="form-field same-height filters-diag"> <mat-label>Diagramaciones</mat-label>
                            <mat-select [(ngModel)]="selectDiagramacionFiltro" (selectionChange)="updateSelectDiagramations()">
                                <mat-option value="1">Atrasadas</mat-option>
                                <mat-option value="2">Próximas a vencer</mat-option>
                                <mat-option value="3">Pendientes</mat-option>
                                 <mat-option value="4">No filtrar</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
              <div class="card-body">
                  <div class="my-3">
                      <div class="row">
                      </div>
                      <div class="card-body">
                        <div class="table-scroll"> 
                          <div 
                            #scrollContainer 
                            class="table-container"
                            (mousedown)="startDragging($event)" 
                            (mousemove)="onDragging($event)" 
                            (mouseup)="stopDragging()" 
                            (mouseleave)="stopDragging()"
                          >
                            <!--T0 : {{t0 | date : "dd/MM/yyyy" }}-->
                              <table class="table table-bordered">
                                  <thead>
                                      <tr>
                                          <th>#</th>
                                          <th colspan="8" class="text-center">Diagramación</th>
                                          <th colspan="2" class="text-center">Inventario</th>
                                          <th *ngFor="let c of projectPhases" [attr.colspan]="c.vobos.length + 1" class="text-center">{{ c.name }}</th>
                                      </tr>
                                      <tr>
                                          <th>ID</th>
                                          <th class="text-center" style="width: 1%">Actions</th>
                                          <th class="text-center">Alias</th>
                                          <th class="text-center">Responsable</th>
                                          <th class="text-center">Sig. Turno</th>
                                          <th class="text-center">Medio</th>
                                          <th class="text-center">POP</th>
                                          <th class="text-center">Posición</th>
                                          <th class="text-center">Files</th>
                                          <th class="text-center" style="width: 1%; white-space: nowrap;">Vendidos</th>
                                          <th class="text-center" style="width: 1%; white-space: nowrap;">Sucursales</th>
                                          <ng-container *ngFor="let c of projectPhases">
                                                <th class="text-center th-date" [matTooltip]="c.porcentaje_terminado + '%' " matTooltipPosition="above" matTooltipClass="tooltip-porcentage">
                                                    <span *ngIf="projectAllDiagramations.length > 0">{{ c.fecha_limite | date : "dd/MM/yyyy"}}</span>
                                                    <span *ngIf="projectAllDiagramations.length == 0"> - </span>
                                                    <span *ngIf="(c.fecha_limite | date:'dd/MM/yyyy') == (fechaFormateada) " class="dot-indicator"></span>
                                                </th>
                                                <th *ngFor="let a of c.vobos" class="text-center th-date" [matTooltip]="a.porcentaje_terminado + '%' " matTooltipPosition="above" matTooltipClass="tooltip-porcentage">
                                                    <span *ngIf="projectAllDiagramations.length > 0">{{a.fecha_limite | date : "dd/MM/yyyy"}}</span>
                                                    <span *ngIf="projectAllDiagramations.length == 0"> - </span>
                                                    <span *ngIf="(a.fecha_limite | date:'dd/MM/yyyy') == (fechaFormateada) " class="dot-indicator"></span>
                                                </th>
                                          </ng-container>
                                      </tr>
                                  </thead>
                                  <tbody class="table-border-bottom-0">
                                      <ng-container *ngFor="let x of filteredDiagramations, let i = index">
                                          <tr>
                                              <td class="min-table text-center">{{ x.id }}</td>
                                              <td class="min-table text-center" style="position: relative;">
                                                <span *ngIf="getDiagramaMenciones(x.id) > 0" class="mention-badge">{{ getDiagramaMenciones(x.id) }}</span>
                                                <button mat-icon-button [matMenuTriggerFor]="menuCampana" matTooltip="Más acciones" [matTooltipPosition]="'above'" color="accent">
                                                    <mat-icon>more_vert</mat-icon>
                                                </button>
                                                <mat-menu #menuCampana="matMenu">
                                                    <button *ngIf="canEditDiagramItem" (click)="openEditProjectDiagramDialog(x)" mat-menu-item>
                                                        <mat-icon>edit</mat-icon> 
                                                        <span>Editar</span>
                                                    </button>
                                                    <button (click)="openDiagramsLogs(x)" mat-menu-item>
                                                        <mat-icon>history</mat-icon>
                                                        <span>Historial</span>
                                                    </button>
                                                    <button (click)="openResumen(x,project)" mat-menu-item> 
                                                        <mat-icon>article</mat-icon> 
                                                        <span>Resumen</span>
                                                    </button>
                                                    <button *ngIf="canGenerateExcel" (click)="imprimirSucursales(x)" mat-menu-item>
                                                        <mat-icon>table_chart</mat-icon>
                                                        <span>Descargar sucursales</span>
                                                    </button>
                                                     <button *ngIf="canResetVoboItem" (click)="openReset(x)" mat-menu-item>
                                                        <mat-icon>restart_alt</mat-icon>
                                                        <span>Resetear VoBo</span>
                                                    </button>
                                                    <button (click)="exportDiagrama(x.id)" mat-menu-item>
                                                        <mat-icon>open_in_new</mat-icon>
                                                        <span>Exportar</span>
                                                    </button>
                                                    <button *ngIf="canDeleteDiagramItem" (click)="deleteProjectDiagramDialog(x)" mat-menu-item>
                                                        <mat-icon>delete</mat-icon>
                                                        <span>Eliminar</span>
                                                    </button>
                                                </mat-menu> 
                                              </td>
                                              <td style="width: 15px;">
                                                  <span style="font-size: 12px;" class="selectable-text">{{x.alias}}</span>
                                            </td>
                                            <td style="width: 15px;">
                                                  <span style="font-size: 12px;" class="selectable-text">{{x.nombre_usuario}}</span>
                                            </td>
                                            <td style="width: 15px;">
                                                  <span style="font-size: 12px; cursor: pointer" class="selectable-text" (click)="openModalUsuariosSigVobo(x.sigUsuariosVobo, x.nextVobo.area, x.nameSigPhase)">
                                                        {{ x.sigUsuariosVobo.length == 0 ? 'Aprobado' : x.sigUsuariosVobo[0]?.name }}
                                                        <span *ngIf="x.sigUsuariosVobo.length > 1" style="background-color: #006EFF; color: white; padding: 2px 4px; border-radius: 4px; margin-left: 4px;">
                                                            +{{ x.sigUsuariosVobo.length - 1 }}
                                                        </span>
                                                  </span>
                                            </td>
                                            <td style="width: 15px;">
                                                <span style="font-size: 12px;" class="selectable-text">{{x.medio}}</span>
                                            </td>
                                            <td style="width: 15px;">
                                                <span style="font-size: 12px;" class="selectable-text">{{x.pop}}</span>
                                            </td>
                                            <td class="min-table text-center" style="width: 1%; white-space: nowrap;">
                                               {{x.posicion}}
                                            </td>
                                            <td class="min-table text-center" style="width: 1%; white-space: nowrap;">
                                               {{x.count_files}}
                                            </td>
                                            
                                              <td class="min-table text-center" style="width: 1%; white-space: nowrap;">{{x.cantidad}}</td>
                                              <td class="min-table text-center" style="width: 1%; white-space: nowrap;">{{x.cant_sucursales}}</td>

                                              <ng-container *ngFor="let c of projectPhases">
                                                <td class="tex-center no-border">
                                                  <div (click)="abrirArteDiagramacion(x, c)" data-toggle="tooltip" data-placement="top" title="Artes" class="text-center badge-google-like" [ngClass]="findFile(x.id, c.id, x)==1? 'success-bdgl' : (findFile(x.id, c.id, x)==0?'error-bdgl':'warning-bdgl')">
                                                    Art
                                                  </div>
                                                </td>
                                                <td *ngFor="let vobo of c.vobos, let i = index" class="text-center" [ngClass]="(i+1) == c.vobos.length? 'no-border-last' : 'no-border'">
                                                    <div *ngIf="!vobo.is_provider_vobo" (click)="openVobosDiagramDialog(x, c, vobo)" data-toggle="tooltip" data-placement="top" title="{{vobo.area}} {{ (getVoboObj(x.config_vobos,vobo)==3)? '(Opcional)': ''  }}" class="text-center badge-google-like" [ngClass]="(getVoboObj(x.config_vobos,vobo)==1)? 'success-bdgl' : (getVoboObj(x.config_vobos,vobo)==2)?'error-bdgl': (getVoboObj(x.config_vobos,vobo)==3)?'alert-bdgl':'warning-bdgl'">
                                                      {{ onlyPick3Lett(vobo.area) }}
                                                    </div>

                                                    <div *ngIf="vobo.is_provider_vobo" (click)="openDialogProviders(x, c, vobo)" data-toggle="tooltip" data-placement="top" title="{{vobo.area}}" class="text-center badge-google-like" [ngClass]="(getVoboObj(x.config_vobos,vobo)==1)? 'success-bdgl' : (getVoboObj(x.config_vobos,vobo)==2)?'error-bdgl':'warning-bdgl'">
                                                        Prv
                                                    </div>
                                                </td>
                                              </ng-container>
                                              <!--<ng-container *ngFor="let c of x.phases">
                                                  <td [attr.colspan]="c.vobosList.length" class="text-center">
                                                    <span class="ms-4 badge bg-label-success cursor-pointer" style="color:black !important;" (click)="openUploadArtFIleDialog()">
                                                     Subir Artes
                                                    </span>
                                                    <span style="white-space: nowrap;"> - 20/10/2024</span>
                                                  </td>
                                              </ng-container>-->
                                          </tr>
                                          <!--<tr>
                                              <ng-container *ngFor="let c of x.phases">
                                                  <td *ngFor="let vobo of c.vobosList, let i = index" class="text-center" [ngClass]="(i+1) == c.vobosList.length? 'no-border-last' : 'no-border'">
                                                      <div (click)="openVobosDiagramDialog()" data-toggle="tooltip" data-placement="top" title="{{vobo.nombre}}" class="text-center badge-google-like" [ngClass]="vobo.approved? 'success-bdgl' : 'warning-bdgl'">
                                                        {{ onlyPick3Lett(vobo.nombre) }}
                                                      </div>
                                                  </td>
                                              </ng-container>
                                          </tr>-->
                                      </ng-container>
                                  </tbody>
                              </table>
                          </div>
                        </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>
